import React from 'react'

import { CheckIcon } from '@heroicons/react/20/solid'
import ReactTooltip from 'react-tooltip'

interface CompleteButtonProps {
  onToggleComplete: () => void
  taskId: number
  completed: boolean
  disabled?: boolean
}

export const CompleteButtonV2: React.FC<CompleteButtonProps> = ({
  onToggleComplete,
  taskId,
  completed,
  disabled = false,
}) => {
  const tooltipText = completed ? 'Mark Task Uncompleted' : 'Mark Task Completed'
  const tooltipId = `task-${taskId}-${completed ? 'uncomplete' : 'complete'}`

  return (
    <>
      <ReactTooltip
        place='right'
        id={tooltipId}
      />
      <button
        onClick={onToggleComplete}
        data-tip={tooltipText}
        data-for={tooltipId}
        disabled={disabled}
        aria-label={tooltipText}
        className={`
          w-[17px] h-[17px]
          flex shrink-0 items-center justify-center
          rounded-[7px] cursor-pointer
          transition-colors duration-200
          ${
            completed
              ? 'bg-success hover:bg-success/90'
              : 'border-gray-200 border hover:border-gray-200'
          }
          ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        `}
      >
        {completed && (
          <CheckIcon
            className='text-white'
            width={10}
          />
        )}
      </button>
    </>
  )
}
